import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'
import { Button } from '@/shared/components/ui/button'
import { useDeactivateOrgMember } from '../hooks/useDeactivateOrgMember'
import type { OrgMember } from '../api/operations'

interface DeactivateUserDialogProps {
  member: OrgMember | null
  onOpenChange: (open: boolean) => void
}

export function DeactivateUserDialog({ member, onOpenChange }: DeactivateUserDialogProps) {
  const { deactivateMember, loading } = useDeactivateOrgMember({
    onSuccess: () => onOpenChange(false),
  })

  const handleConfirm = async () => {
    if (!member) return
    await deactivateMember(member.id)
  }

  return (
    <Dialog open={!!member} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Desactivar usuario</DialogTitle>
          <DialogDescription>
            {member ? (
              <>
                Vas a desactivar a <strong>{member.email}</strong>. Perderá acceso al portal
                inmediatamente y se conservará su historial dentro de la organización.
              </>
            ) : null}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            type="button"
            variant="ghost"
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            variant="danger"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Desactivando…' : 'Desactivar usuario'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
